export default "__VITE_ASSET__Iu9PM7pB__ 224w, __VITE_ASSET__BvSCDYP$__ 448w";